import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let submitTab = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })
  let patientId = useDataValue({
    viewPath: props.viewPath,
    context: 'appointment_overlay',
    path: 'patient_id',
  })
  let isPatientOverlayCall = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'appointment_overlay.is_patient_overlay_call',
  })
  let submitGlobal = useDataSubmit({
    viewPath: props.viewPath,
    context: 'global',
  })

  return function onClick() {
    if (isPatientOverlayCall && patientId) {
      return submitGlobal({
        type: 'patientOverlay/open',
        patient_id: patientId,
      })
    }

    return submitTab({ type: 'appointmentOverlay/close' })
  }
}
